import KundeService from '@/services/KundeService'

const state = {
  items: [],
  pageCount: 1,
  queryParams: {
    page: 1,
    sort: 'Sist_endret_tid',
    direction: 'desc'
  },
  loading: false,
  updating: false,
  needreload: true
}

const getters = {
  items: state => state.items,
  pageCount: state => state.pageCount,
  queryParams: state => state.queryParams,
  loading: state => !!state.loading,
  updating: state => !!state.updating,
  needreload: state => !!state.needreload
}

const actions = {
  load: ({commit, dispatch}, Kundenr) => {
    return new Promise((resolve, reject) => {
      commit('load')

      KundeService.getKundeFullmakter(Kundenr, state.queryParams)
        .then((response) => {
          let payload = {
            items: response.data,
            pageCount: response.headers['x-paging-pagecount'] ? parseInt(response.headers['x-paging-pagecount']) : 1
          }

          commit('success', payload)
          resolve(response)
        })
        .catch((error) => {
          commit('failure')
          reject(error)
        })
    })
  },
  save: ({commit, dispatch}, data) => {
    return new Promise((resolve, reject) => {
      KundeService.addKundeFullmakt(data.kundenr, data.fullmaktId, data.data)
        .then((response) => {
          console.log(response)

          commit('success_save', response.data)
          resolve(response)
        })
        .catch((error) => {
          commit('failure_save')
          reject(error)
        })
    })
  },
  // delete: ({commit, dispatch}, data) => {
  //   return new Promise((resolve, reject) => {
  //     commit('delete')

  //     KontraktService.delKontraktNotat(data.Kontraktnr, data.id)
  //       .then((response) => {
  //         commit('success_delete', data.id)
  //         resolve(response)
  //       })
  //       .catch((error) => {
  //         commit('failure_delete')
  //         reject(error)
  //       })
  //   })
  // },
  reload: ({commit, dispatch}, params) => {
    commit('reload', params.queryParams || null)
    dispatch('load', params.Kundenr)
  },
  setNeedReload: ({commit, dispatch}) => {
    commit('setNeedReload')
  }
}

const mutations = {
  load: (state) => {
    if (!state.updating) {
      state.loading = true
    }
  },
  reload: (state, payload) => {
    state.updating = true

    if (payload !== null) {
      state.queryParams = payload
    }
  },
  save: (state) => {
    state.updating = true
  },
  // delete: (state) => {
  //   state.updating = true
  // },
  success: (state, payload) => {
    state.loading = false
    state.updating = false

    state.items = payload.items || []
    state.pageCount = payload.pageCount
    state.needreload = false
  },
  failure: (state) => {
    state.loading = false
    state.updating = false

    state.items = []
    state.pageCount = 1
    state.needreload = true
  },
  success_save: (state, payload) => {
    state.loading = false
    state.updating = false

    if (!state.items || state.items.length < 1) {
      // First time we add something
      state.items.unshift(payload)
    } else {
      // If update, we already have this one.
      let index = state.items.findIndex(x => x.id === payload.id)

      if (index >= 0) {
        Object.assign(state.items[index], payload)
      } else {
        state.items.unshift(payload)
      }
    }
  },
  failure_save: (state) => {
    state.loading = false
    state.updating = false
  },
  // success_delete: (state, notatId) => {
  //   state.loading = false
  //   state.updating = false

  //   if (state.items) {
  //     let index = state.items.findIndex(x => x.id === notatId)
  //     state.items.splice(index, 1)
  //   }
  // },
  // failure_delete: (state) => {
  //   state.loading = false
  //   state.updating = false
  // },
  setNeedReload: (state) => {
    state.needreload = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/kundefullmakt.js